<template>
  <el-card>
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">Refund Requests</span>
      <div class="ring-card__header-buttons">
        <RefreshButton @click.native="loadRequests()" />
      </div>
    </div>
    <div
        v-loading="loading"
        class="card-content">
      <el-table
          ref="refundsTable"
          :data="requests"
          class="requests"
          style="width: 100%"
          @cell-click="toggleRowExpansion">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <customer-request-logs :request="scope.row" />
          </template>
        </el-table-column>
        <el-table-column
            sortable
            prop="status"
            label="Status"
            width="120">
          <template slot-scope="scope">
            <div
                :class="scope.row.status"
                class="indicator"
                style="display: flex; align-items: center;">
              <!-- <font-awesome-icon
                size="sm"
                icon="circle"/>
              &nbsp;&nbsp; -->
              <span>{{ scope.row.status_name || getStatus(scope.row.status) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            width="220"
            sortable
            prop="created_at"
            :label="$t('requests.uuid')">
          <template slot-scope="scope">
            {{ scope.row.uuid | uppercase }}
            <div style="color: #C0C0C0">
              <time-zone-formatter :current-time="scope.row.created_at" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
            :label="$t('requests.product')"
            min-width="200">
          <template slot-scope="scope">
            <span style="word-break: break-word;">{{ scope.row.old_product }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="device_id"
            class-name="important"
            :label="$t('requests.device_id')"
            min-width="160" />
        <el-table-column
            prop="return_label_id"
            class-name="important"
            label="Return Label"
            min-width="180" />
        <el-table-column
            sortable
            prop="agent"
            min-width="200"
            :label="$t('requests.agent')" />
        <el-table-column
            min-width="100"
            :index="99"
            label="">
          <template slot-scope="scope">
            <cancel-request-button
                v-if="canCancel(scope.row)"
                :request="scope.row"
                @reload="loadRequests" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { get } from "lodash";
import CustomerRequestLogs from "./CustomerRequestLogs";
import CancelRequestButton from "@/components/Shared/cancelRequestButton";
import RefreshButton from "@/containers/Customer/RefreshButton";

export default {
  name: "RefundList",
  components: { CustomerRequestLogs, CancelRequestButton, RefreshButton },
  props: {
    requests: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    statusList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      statusNames: {
        paid: "Refund paid",
        failed: "Failed",
        on_hold: "On hold",
        canceled: "Canceled",
        pending: "Pending",
      },
    };
  },
  updated() {
    if (this.requests.length) {
      let rows = get(this.$refs.refundsTable, "$options.propsData.data", {});
      if (rows.constructor.name === "Array" && rows.length === 1) {
        // expand row by default if there is only one
        this.$refs.refundsTable.toggleRowExpansion(rows[0]);
      }
    }
  },
  methods: {
    loadRequests() {
      this.$emit("reload");
    },
    toggleRowExpansion(row, column) {
      if (column.index === 99) return;
      this.$refs.refundsTable.toggleRowExpansion(row);
    },
    getStatus(value) {
      let status = this.statusList.find((s) => s.value == value.toLowerCase());
      if (status) return status.label;
      else return "N/A";
    },
    canCancel(request) {
      if (request.cancellable == undefined)
        return [
          "label_crated",
          "manual_tracking",
          "waiting_for_updates",
          "pending",
        ].indexOf(request.status);
      else return request.cancellable;
    },
  },
};
</script>

<style>
.el-table.requests td {
  vertical-align: baseline !important;
}
</style>
